<template>
  <v-card :loading="loading">
    <v-card-title class="font-weight-regular">
      {{ $t('EMPLOYEES.MAIN_INFORMATION') }}
      <v-icon
        v-if="isManuallyType() && !editMode"
        class="ml-2"
        color="indigo"
        @click="toggleEditMode"
      >
        mdi-square-edit-outline
      </v-icon>
      <v-spacer />

      <div>
        <v-select
          :value="Number(form.main_information.is_active)"
          solo
          flat
          :items="statuses"
          item-value="id"
          item-text="name"
          small-chips
          hide-details
          dense
          :disabled="!editMode"
          style="width: 130px"
          @change="v => (form.main_information.is_active = Boolean(v))"
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              small
              :color="item.color"
              dark
              class="ml-1"
              v-bind="attrs"
              :input-value="selected"
              @click="select"
            >
              {{ item.name }}
            </v-chip>
          </template>
        </v-select>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-form v-model="valid">
        <employee-main-info-form
          v-model="form.main_information"
          :readonly="!editMode"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
        <v-row dense>
          <v-col cols="12" class="pt-0">
            <div v-if="editMode">
              <v-btn
                outlined
                class="mr-5"
                depressed
                color="grey"
                large
                @click="cancel"
              >
                {{ $t('BUTTON.CANCEL') }}
              </v-btn>
              <v-btn
                depressed
                type="submit"
                :disabled="!valid"
                large
                color="primary"
                class="mr-5"
                @click.prevent="updateEmployee"
              >
                {{ $t('BUTTON.UPDATE') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import editComponent from '@/modules/_global/mixins/edit-component';
import isManuallyType from '@/modules/employees/components/mixins/is-manually-type';
import EmployeeMainInfoForm from '@/modules/employees/components/forms/EmployeeMainInfoForm';
import { EmployeesService } from '@/services/employees.service';
import { mapCacheActions } from 'vuex-cache';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'EmployeesMainInfoEdit',

  components: { EmployeeMainInfoForm },

  mixins: [editComponent, isManuallyType, i18nRefreshData],

  data() {
    return {
      statuses: []
    };
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('employee', ['getEmployeeStatuses']),

    getDataEmployeeStatuses() {
      return this.getEmployeeStatuses().then(({ data }) => {
        this.statuses = data.data;
      });
    },

    refreshData() {
      this.getDataEmployeeStatuses();
    },

    updateEmployee() {
      EmployeesService.update(this.form.id, this.form.main_information)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('update', data);
          this.toggleEditMode();
        })
        .catch(this.handleErrors);
    }
  }
};
</script>

<style scoped></style>
